import { render, staticRenderFns } from "./point_exchange_order.vue?vue&type=template&id=168dc311&scoped=true"
import script from "./point_exchange_order.vue?vue&type=script&lang=js"
export * from "./point_exchange_order.vue?vue&type=script&lang=js"
import style0 from "./point_exchange_order.vue?vue&type=style&index=0&id=168dc311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168dc311",
  null
  
)

export default component.exports